import PositionsDrawerCard from './positions-drawer-card';

export default PositionsDrawerCard;
